export const keithherings = [
  { image: "/images/keithhering/1.jpg" },
  { image: "/images/keithhering/2.jpg" },
  { image: "/images/keithhering/3.jpg" },
];
